import React from "react";
import styled from "styled-components";

const Container = styled.div`
  height: 19.8px;
  width: 22.2px;
  margin: auto;

  @media (min-width: 1800px) {
    height: 24px;
    width: 27px;
  }

  @media (max-width: 575px) {
    height: 17.5px;
    width: 20px;
  }
`;

const LikeFilled = () => {
  return (
    <Container>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="100%"
        width="100%"
        viewBox="0 0 14.134 15.741"
      >
        <g fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="0.75">
          <path
            d="M9.58 10.201h0a.967.967 0 01-.749-1.144l.721-3.463a.967.967 0 011.144-.749h0a.967.967 0 01.749 1.144l-.721 3.463a.968.968 0 01-1.144.749z"
            transform="translate(.378 .394)"
          />
          <path
            d="M5.198 10.223a12.375 12.375 0 00-1.245-2.22C3.486 7.515 1.773 5.744.891 6.09s-1.246.973-.433 1.791a6.512 6.512 0 012.14 3.206c.227 1.342.556 2.91 1.559 3.432a6.188 6.188 0 003.114.235c.8-.026 3.546.566 4.239 0s1.436-.875 1.141-4.232"
            transform="translate(.378 .394)"
          />
          <path
            d="M11.476 11.21h0a.967.967 0 01-.749-1.144l.721-3.463a.967.967 0 011.144-.749h0a.967.967 0 01.749 1.144l-.721 3.463a.968.968 0 01-1.144.749zM8.928 8.844l1.232-7.679A.968.968 0 009.411.021h0A.968.968 0 008.267.77l-1.113 6.7h-.226l-1.26-5.634a.967.967 0 00-1.09-.824h0a.967.967 0 00-.821 1.1L5.18 10.33"
            transform="translate(.378 .394)"
          />
        </g>
      </svg>
    </Container>
  );
};

export default LikeFilled;
